import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BlobProvider } from '@react-pdf/renderer';
import React from 'react';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import ButtonIcon from '../../components/common/ButtonIcon';
import ContratoNovacion from './contrato/ContratoNovacion';

const ContratoNovacionModal = ({ open, data, onOk }) => {
    const fileName = `contrato_novacion_${data?.credito?.numero || ''}.pdf`;

    return (
        <Modal size="lg" isOpen={open}>
            <ModalHeader>
                <h5>Contrato de Novación</h5>
                <span className="text-primary" style={{ fontSize: '0.8em' }}>
                    {data?.credito?.numero ? `Crédito ${data.credito.numero}` : ''}
                </span>
            </ModalHeader>
            <ModalBody className="p-3">
                <div className="text-center mt-4">
                    <FontAwesomeIcon icon="check" transform="shrink-2" className="text-success mr-1 fs-8" />
                    <h6 className="fs-2 m-3">Liquidación Completa!</h6>
                    <p className="fs--1">
                        Imprima el contrato y recójalo firmado por el cliente antes del desembolso.
                    </p>
                    {data && (
                        <BlobProvider document={<ContratoNovacion data={data} />}>
                            {({ url, loading, error }) => {
                                if (loading) {
                                    return (
                                        <span className="fs--1">
                                            <Spinner size="sm" color="primary" className="mr-2" />
                                            Generando contrato...
                                        </span>
                                    );
                                }
                                if (error) {
                                    return <span className="fs--1 text-danger">No se pudo generar el contrato</span>;
                                }
                                return (
                                    <div>
                                        {/* Enlace y no window.open: el navegador puede bloquear la
                                            ventana emergente sin avisar y el botón queda muerto. */}
                                        <ButtonIcon
                                            color="falcon-default"
                                            size="sm"
                                            icon="print"
                                            className="mr-2 mb-2 mb-sm-0"
                                            tag="a"
                                            href={url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Ver e imprimir
                                        </ButtonIcon>
                                        <ButtonIcon
                                            color="falcon-default"
                                            size="sm"
                                            icon="arrow-down"
                                            className="mr-2 mb-2 mb-sm-0"
                                            tag="a"
                                            href={url}
                                            download={fileName}
                                        >
                                            Descargar contrato
                                        </ButtonIcon>
                                    </div>
                                );
                            }}
                        </BlobProvider>
                    )}
                </div>
            </ModalBody>
            <ModalFooter className="no-border">
                <Col className="text-right">
                    <Button onClick={onOk} transform="shrink-3 down-2" color="primary">
                        Aceptar
                    </Button>
                </Col>
            </ModalFooter>
        </Modal>
    );
};

export default ContratoNovacionModal;
